'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _GrowthSuiteCatalogModal = require('pricing-pages-unified-ui/components/growth-suite-catalog/GrowthSuiteCatalogModal');

var _GrowthSuiteCatalogModal2 = _interopRequireDefault(_GrowthSuiteCatalogModal);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuiteViewAllFeatures = function SuiteViewAllFeatures(_ref) {
  var edition = _ref.edition,
      currencyCode = _ref.currencyCode;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var gaClassName = (0, _publicPageUrls.getGAClassName)('growth' + edition + '-pricing-features');

  var toggleViewAllFeaturesModal = function toggleViewAllFeaturesModal() {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      (0, _getUsageTracker2.default)().track('clickToViewModal', {
        name: 'compare-feature-modal',
        edition: edition,
        inCalculator: false
      });
    }
  };

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      _UIButton2.default,
      {
        className: 'm-left-0 ' + gaClassName,
        onClick: toggleViewAllFeaturesModal,
        use: 'link'
      },
      _react2.default.createElement(_FormattedMessage2.default, {
        className: gaClassName,
        message: 'pricingPage.highlightedMerchCards.seeAllFeatures'
      })
    ),
    isModalOpen && _react2.default.createElement(_GrowthSuiteCatalogModal2.default, {
      edition: edition,
      onCloseClick: toggleViewAllFeaturesModal,
      currencyCode: currencyCode
    })
  );
};

SuiteViewAllFeatures.propTypes = {
  edition: _react.PropTypes.string,
  currencyCode: _react.PropTypes.string
};

exports.default = SuiteViewAllFeatures;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteViewAllFeatures.js
// module id = 775
// module chunks = 3 4